"use client";

import ShareButton from "@/components/shareButton";
import { Button } from "antd";
import { IconShare } from "@/lib/icons";

const OrganizerShareButton = ({ name, image, eventDetails, ...props }) => {
  const details = eventDetails || {
    name,
    image,
    subtitle: "Organizer",
  };

  return (
    <ShareButton
      shareType="organizer"
      eventDetails={details}
      {...props}
    >
      <Button
        type="default"
        icon={<IconShare size={18} />}
        className="!h-9 sm:!h-10 !rounded-lg !px-4 !font-semibold !text-xs sm:!text-sm !border-[#021526]/15 hover:!border-[#021526] hover:!text-[#021526] transition-all duration-200 flex items-center gap-2"
      >
        Share Organizer
      </Button>
    </ShareButton>
  );
};

export default OrganizerShareButton;

